var next = __webpack_require__.x
__webpack_require__.x = () => {
  return __webpack_require__.e("vendors-node_modules_react-dom_index_js-node_modules_react_index_js").then(next);
}